import React from "react";
import Ring from "@/components/ui/Ring";
import { useActualsStore } from "@/state/actuals/actualsStore";
import Header from "./Header";
import CommonEquity from "./common-equity/CommonEquity";
import DataSourceInfo from "./data-source-info/DataSourceInfo";
import PreferredEquity from "./preferred-equity/PreferredEquity";
import Convertibles from "./convertibles/Convertibles";
import Cash from "./cash/Cash";
import Debt from "./debt/Debt";
import DebtEquivalents from "./debt-equivalents/DebtEquivalents";

const Actuals: React.FC = () => {
  const { activeTab } = useActualsStore((state) => state);

  return (
    <div className="w-full flex flex-col gap-4">
      <Ring className="mt-4 px-4 gap-8">
        <Header />
      </Ring>

      {activeTab === "common-equity" && <CommonEquity />}
      {activeTab === "data-source-info" && <DataSourceInfo />}
      {activeTab === "preferred-equity" && <PreferredEquity />}
      {activeTab === "convertibles" && <Convertibles />}
      {activeTab === "cash" && <Cash />}
      {activeTab === "debt" && <Debt />}
      {activeTab === "debt-equivalents" && <DebtEquivalents />} 
    </div>
  );
};

export default Actuals;

